import React from "react";
import { motion } from "framer-motion";
import { Image } from "./image";
import { Icon } from "./icon";

export const Gallery = (props) => {
  const items = props.data || [];

  return (
    <section id="portfolio" className="section bg-navy-50/50">
      <div className="container">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="eyebrow">Selected work</span>
            <h2 className="section-heading mt-6">
              Products we've designed,
              <span className="gradient-text"> built and shipped</span>
            </h2>
          </div>
          <a href="#contact" className="btn-outline group shrink-0">
            Start your project
            <Icon
              name="arrowRight"
              className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
            />
          </a>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {items.map((d, i) => (
            <motion.div
              key={`${d.title}-${i}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: (i % 3) * 0.09, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            >
              <Image
                title={d.title}
                category={d.category}
                largeImage={d.largeImage}
                smallImage={d.smallImage}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
